<template>
    <b-card class="home-content-card">
        <home-introduction :home-section="homeSection" />

        <benefits :home-section="homeSection" />
    </b-card>
</template>

<script>
    import HomeIntroduction from "../HomeIntroduction/HomeIntroduction";
    import LandingPageHomeSectionAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageHomeSectionAppResource";
    import Benefits from "../Benefits/Benefits";
    export default {
        name: "HomeContentCard",
        components: {Benefits, HomeIntroduction},
        props: {
            homeSection: {
                type: LandingPageHomeSectionAppResource,
                required: true,
            },
        }
    };
</script>
